/**
 * Utility functions and constants for MainMenu component
 */

/** Navigation item shape */
export interface NavItem {
  path?: string;
  text: string;
  Icon: string;
  isParent?: boolean;
  children?: NavItem[];
}

/** The main navigation items configuration */
export const navItems: NavItem[] = [
  { path: "/dashboard", text: "Dashboard", Icon: "dashboard" },
  { path: "/insights", text: "Insights", Icon: "insights" },
  { path: "/locationmap", text: "Locations", Icon: "map" },
  { path: "/assets", text: "Assets", Icon: "deployed_code" },
  { path: "/inspection-orders", text: "Inspection Orders", Icon: "assignment" },
  { path: "/workorders", text: "Work Orders", Icon: "work" },
  // { path: "/obligations", text: "Obligations", Icon: "task" },
  { path: "/task-list", text: "Task List", Icon: "checklist" },
  { path: "/document-library", text: "Document Library", Icon: "folder" },
  { path: "/support", text: "Support", Icon: "support_agent" },
  { path: "/team", text: "Team", Icon: "groups" },
];

/** Get user initials (up to 2 chars) from a name string */
export const getInitials = (name?: string | null): string => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  const initials = parts
    .map((part) => part.charAt(0).toUpperCase())
    .join("")
    .slice(0, 2);
  return initials || "?";
};

/** Inactive sidebar text color */
export const INACTIVE_COLOR = "rgba(255, 255, 255, 0.72)";
